/* global __webpack_init_sharing__, __webpack_share_scopes__ */
// utils/customImportRemote.js

/**

- Dynamically loads a remote module from another federated app.
- @param {Object} config
- @param {string} config.url - Base URL of the remote app
- @param {string} config.scope - Container scope (usually the name used in ModuleFederationPlugin)
- @param {string} config.module - Module path exposed by the remote container
- @param {string} [config.remoteEntryFileName='remoteEntry.js'] - Name of the remote entry file
- @returns {Promise<any>} The loaded module (e.g., a React component)
*/
export async function CustomImportRemote(_ref) {
  let {
    url,
    scope,
    module,
    remoteEntryFileName = 'remoteEntry.js'
  } = _ref;
  const remoteEntryUrl = `${url}/${remoteEntryFileName}`;

  // Load remote entry only once
  if (!window[scope]) {
    await new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = remoteEntryUrl;
      script.type = "text/javascript";
      script.async = true;
      script.onload = resolve;
      script.onerror = () => reject(new Error(`Failed to load remoteEntry: ${remoteEntryUrl}`));
      document.head.appendChild(script);
    });
  }

  // Share scope initialization (required for Module Federation)
  await __webpack_init_sharing__("default");
  const container = window[scope];

  // Initialize the container if not already done
  if (!container.__initialized) {
    await container.init(__webpack_share_scopes__.default);
    container.__initialized = true;
  }
  const factory = await container.get(module);
  return factory();
}